import angular from 'angular';
import { routes } from './routes';
import { react2angular } from 'react18-react2angular';
import GasAgendamentosListView from './list';
import { useContext } from '@components';
export default angular
    .module('app.gas.agendamentos', [])
    .config(routes)
    .component('gasAgendamentosListView', react2angular(useContext.use(GasAgendamentosListView), [], ['$state', 'GasService', 'UIService'])).name;
